import theme from "@/styles/theme";
import styled from "styled-components";
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  .top-tools-container {
    display: none;
    @media ${theme.devices.tablet} {
      display: flex;
      flex-direction: column;
      width: 100%;
    }
  }
  .search-container {
    display: none;
    @media ${theme.devices.tablet} {
      display: flex;
      margin-left: 6%;
      margin-right: 5%;
      margin-bottom: 2vh;
    }
  }
  .datagrid-container {
    display: flex;
    width: 75vw;
    height: 75vh;
    align-self: center;
    flex-direction: column;
    @media ${theme.devices.tablet} {
      width: 90vw;
      height: 80vh;
    }
  }
`;

export const AccountSelectContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: 35vw;
  min-width: 35vw;
  width: 100%;
  .label {
    color: white;
    width: 100%;
    font-size: ${theme.fontSize.mm};
    text-align-last: right;
    margin-right: 1vw;
    @media ${theme.devices.tablet} {
      text-align-last: auto;
      margin-left: 5vw;
      width: 70vw;
    }
  }
  @media ${theme.devices.tablet} {
    max-width: 95vw;
    min-width: 95vw;
    column-gap: 0px;
    margin-bottom: 2vh;
  }
`;
export const DgContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 95%;
  align-self: center;
  .datagrid-container {
    display: flex;
    width: 75vw;
    height: 75vh;
    align-self: center;
    flex-direction: column;
    @media ${theme.devices.tablet} {
      width: 90vw;
      height: 80vh;
    }
  }
`;